

class StoreUpdateEvents  {
    static SESSION_STORE_UPDATED = Symbol("SESSION_STORE_UPDATED");
    static LOGIN_VIEW_STORE_UPDATED = Symbol("LOGIN_VIEW_STORE_UPDATED");
    static MEMBER_STORE_UPDATED = Symbol("MEMBER_STORE_UPDATED");
    static SERP_STORE_UPDATED = Symbol("SERP_STORE_UPDATED");
    static SEARCH_FILTERS_STORE_UPDATED = Symbol("SEARCH_FILTERS_STORE_UPDATED");
    static PROFILE_STORE_UPDATED = Symbol("PROFILE_STORE_UPDATED");
    static PROFILE_CREATE_VIEW_STORE_UPDATED = Symbol("PROFILE_CREATE_VIEW_STORE_UPDATED");
    static EMAIL_VERIFICATION_VIEW_STORE_UPDATED = Symbol("EMAIL_VERIFICATION_VIEW_STORE_UPDATED");
    static PHONE_NUMBER_VERIFICATION_VIEW_STORE_UPDATED = Symbol("PHONE_NUMBER_VERIFICATION_VIEW_STORE_UPDATED");
    static GOOGLE_API_LIB_STORE_UPDATED = Symbol("GOOGLE_API_LIB_STORE_UPDATED");
    static ERROR_STORE_UPDATED = Symbol("ERROR_STORE_UPDATED");
    static PUBLIC_SPACE_STORE_UPDATE = Symbol("PUBLIC_SPACE_STORE_UPDATE");
    static PRIVATE_SPACE_DETAILS_STORE_UPDATE = Symbol("PRIVATE_SPACE_DETAILS_STORE_UPDATE");
    static PRIVATE_MY_SPACES_STORE_UPDATE = Symbol("PRIVATE_MY_SPACES_STORE_UPDATE");
    static SPACE_CREATE_VIEW_STORE_UPDATED = Symbol("SPACE_CREATE_VIEW_STORE_UPDATED");
    static SPACE_EDIT_VIEW_STORE_UPDATED = Symbol("SPACE_EDIT_VIEW_STORE_UPDATED");
    static SPACE_RESERVATIONS_STORE_UPDATED = Symbol("SPACE_RESERVATIONS_STORE_UPDATED");
    static ADVERTISEMENT_RESERVATIONS_STORE_UPDATED = Symbol("ADVERTISEMENT_RESERVATIONS_STORE_UPDATED");
    static ADVERTISEMENT_CREATE_VIEW_STORE_UPDATED = Symbol("ADVERTISEMENT_CREATE_VIEW_STORE_UPDATED");
    static IMAGE_UPLOADER_STORE_UPDATED = Symbol("IMAGE_UPLOADER_STORE_UPDATED");
    static PRIVATE_MY_ADVERTISEMENTS_STORE_UPDATE = Symbol("PRIVATE_MY_ADVERTISEMENTS_STORE_UPDATE");
    static ADVERTISEMENT_STORE_UPDATE = Symbol("ADVERTISEMENT_STORE_UPDATE");
    static ADVERTISEMENT_BILLING_STORE_UPDATE = Symbol("ADVERTISEMENT_BILLING_STORE_UPDATE");
    static SPACE_BALANCE_STORE_UPDATE = Symbol("SPACE_BALANCE_STORE_UPDATE");
    static MEMBER_SPACE_CALENDAR_STORE_UPDATED = Symbol("MEMBER_SPACE_CALENDAR_STORE_UPDATED");
    static ADVERTISEMENT_EDIT_VIEW_STORE_UPDATED = Symbol("ADVERTISEMENT_EDIT_VIEW_STORE_UPDATED");
    static ADVERTISEMENT_OWNER_PROFILE_STORE_UPDATE = Symbol("ADVERTISEMENT_OWNER_PROFILE_STORE_UPDATE");
    static CHECKOUT_VIEW_STORE_UPDATE = Symbol("CHECKOUT_VIEW_STORE_UPDATE");
    static SPACE_OWNER_PROFILE_STORE_UPDATE = Symbol("SPACE_OWNER_PROFILE_STORE_UPDATE");
    static PROFILE_EDIT_VIEW_STORE_UPDATED = Symbol("PROFILE_EDIT_VIEW_STORE_UPDATED");
}

export default StoreUpdateEvents;